var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }, [_c("w-spacer")], 1),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [
                        _vm._v(_vm._s(_vm.$ct("vat-percentages"))),
                      ]),
                      _c(
                        "w-list",
                        [
                          _vm._l(_vm.vats, function (vat) {
                            return _c(
                              "w-list-item",
                              { key: vat.ID },
                              [
                                _c("w-list-item-text", [
                                  _vm._v(_vm._s(vat.Value) + "%"),
                                ]),
                                _c(
                                  "w-list-item-action",
                                  [
                                    _c(
                                      "w-button",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: _vm.$ct(
                                              "edit-vat-percentage"
                                            ),
                                            expression:
                                              "$ct('edit-vat-percentage')",
                                          },
                                        ],
                                        on: {
                                          click: function ($event) {
                                            return _vm.edit(vat)
                                          },
                                        },
                                      },
                                      [_c("w-fa", { attrs: { icon: "pen" } })],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "w-list-item-action",
                                  [
                                    _c(
                                      "w-button",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: _vm.$ct(
                                              "remove-vat-percentage"
                                            ),
                                            expression:
                                              "$ct('remove-vat-percentage')",
                                          },
                                        ],
                                        staticClass: "danger",
                                        on: {
                                          click: function ($event) {
                                            return _vm.remove(vat)
                                          },
                                        },
                                      },
                                      [
                                        _c("w-fa", {
                                          attrs: { icon: "trash" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                          _c(
                            "w-list-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.openCreateNewVatModal()
                                },
                              },
                            },
                            [
                              _c("w-list-item-text", [
                                _c(
                                  "div",
                                  [
                                    _c("w-fa", { attrs: { icon: "plus" } }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$ct("add-new-vat-percentage")
                                        ) +
                                        " "
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.toEditVat
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c("app-vat-edit-modal", {
                on: {
                  close: function ($event) {
                    return _vm.cancel()
                  },
                },
                model: {
                  value: _vm.toEditVat,
                  callback: function ($$v) {
                    _vm.toEditVat = $$v
                  },
                  expression: "toEditVat",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }